import { RepositoryFactory } from '@/repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '@/services/CredentialsService.js'

const HorseshoeWorkRepository = RepositoryFactory.get('horseshoeWork')

class HorseshoeWorkService {
  static async getHorseshoeWorks (params) {
    try {
      return await HorseshoeWorkRepository.getHorseshoeWorks(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default HorseshoeWorkService
